module.exports = __webpack_public_path__ + "dingbeauty-landing/img/system_02@1.860f442c.png";